import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinTagCategory = {
  async tagBySite(arg = { params: {} }) {
    let [err, res] = [null, null]
    const listObj = {
      siteId: ' ',
      pageNo: 1,
      pageSize: 10,
      parentId: ' ',
      keWords: ' ',
    }
    if (arg.params) {
      _.assign(listObj, arg.params)
    }
    ;[err, res] = await To(
      wizStandardInstance.get(
        encodeUrl(
          `/api/TagClass/GetTagListByAsync/${listObj.siteId}/${listObj.pageNo}/${listObj.pageSize}/${listObj.parentId}/${listObj.keWords}`
        )
      )
    )
    return Callback.globalCB(err, res)
  },
  async apiIcons() {
    // let [err, res] = [null, null]
    const [err, res] = await To(
      wizStandardInstance.get(encodeUrl('/api/TagClass/GetIconListAsync'))
    )
    return Callback.globalCB(err, res)
  },
  async tagListByClassId(arg = { params: {} }) {
    let [err, res] = [null, null]
    const listObj = {
      classId: ' ',
      isRelation: 1,
      pageNo: 1,
      pageSize: 10,
      keWord: ' ',
    }
    if (arg.params) {
      _.assign(listObj, arg.params)
    }
    ;[err, res] = await To(
      wizStandardInstance.get(
        encodeUrl(
          `/api/TagClass/GetTagListByClassIdAsync/${listObj.classId}/${listObj.isRelation}/${listObj.pageNo}/${listObj.pageSize}/${listObj.keWord}`
        )
      )
    )
    return Callback.globalCB(err, res)
  },
  async tagAttrTem() {
    // let [err, res] = [null, null]
    const [err, res] = await To(
      wizStandardInstance.get('/api/TagClass/GetTagAttributeTemplateListByCodeOrNameAsync')
    )
    return Callback.globalCB(err, res)
  },
  async apiExportTagClassExcl(arg = { method: '', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    const config = {
      responseType: 'arraybuffer',
    }
    if (arg.config) {
      _.assign(config, arg.config)
    }
    switch (arg.method) {
      case 'importExcelById':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/TagClass/ExportByIdAsync', arg.params)
        )
        break
      case 'exportEmptyExcel':
        ;[err, res] = await To(wizStandardInstance.get('/api/TagClass/handover/downloadasync'))
        break
      default:
        const listObj = {
          id: ' ',
          keWord: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/TagClass/ExportAsync/${listObj.id}/${listObj.keWord}`)
          )
        )
    }
    return Callback.globalCBForOld(err, res)
  },
  async apiTagCategory(arg = { method: 'list', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'importExcel':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/TagClass/handover/ImportExcelAsync', arg.formData)
        )
        break
      case 'add':
        ;[err, res] = await To(wizStandardInstance.post('/api/TagClass/InsertAsync', arg.params))
        break
      case 'edit':
        ;[err, res] = await To(wizStandardInstance.post('/api/TagClass/ModifyAsync', arg.params))
        break
      case 'delete':
        ;[err, res] = await To(wizStandardInstance.post('/api/TagClass/RemoveAsync', arg.params))
        console.log('arg.params', arg.params)
        break
      case 'deleteTag':
        const deleteTagObj = {
          id: ' ',
        }
        if (arg.params && arg.params.id) {
          _.assign(deleteTagObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post(`/api/TagClass/removetagasync/${deleteTagObj.id}`, arg.formData)
        )
        break
      case 'detail':
        const detailObj = {
          id: ' ',
        }
        if (arg.params) {
          _.assign(detailObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/TagClass/GetTagClassViewAsync/${detailObj.id}`))
        )
        break
      case 'classTree':
        const classTreeObj = {
          id: ' ',
        }
        if (arg.params) {
          _.assign(classTreeObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/TagClass/getsuperiortagclasstreeasync/${classTreeObj.id}`)
          )
        )
        break
      case 'tree':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl('/api/TagClass/GetTagClassTreeAsync'))
        )
        break
      default:
        const listObj = {
          pageNo: 1,
          pageSize: 10,
          sortName: ' ',
          sortType: 0,
          parentId: ' ',
          keyWord: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/TagClass/GetListPageByConditionAsync/${listObj.pageNo}/${listObj.pageSize}/${listObj.sortName}/${listObj.sortType}/${listObj.parentId}/${listObj.keyWord}`
            )
          )
        )
    }
    return Callback.globalCB(err, res)
  },
}

export default {
  methods: ApiMixinTagCategory,
}
